import React, { ChangeEvent, DragEvent, RefObject } from "react"

interface Props {
     isDragging: boolean
     fileInputRef: RefObject<HTMLInputElement>
     onDragOver: (e: DragEvent) => void
     onDragLeave: () => void
     onDrop: (e: DragEvent) => void
     onFileSelect: (e: ChangeEvent<HTMLInputElement>) => void
}

const Dropzone = ({ isDragging, fileInputRef, onDragOver, onDragLeave, onDrop, onFileSelect }: Props) => (
     <div
          onDragOver={onDragOver}
          onDragLeave={onDragLeave}
          onDrop={onDrop}
          onClick={() => fileInputRef.current?.click()}
          className={`rounded border-2 border-dashed p-10 mb-10 d-flex flex-column align-items-center transition-all ${
               isDragging ? "bg-light-success border-success" : "bg-body-secondary border-secondary-subtle"
          }`}
          style={{ cursor: "pointer" }}
     >
          <i className="fas fa-cloud-upload-alt fs-2x text-primary mb-3"></i>
          <div className="text-center">
               <span className="text-gray-900 fw-bold fs-4">
                    {/* DESKTOP TEXT: Visible on medium screens and up */}
                    <span className="d-none d-md-inline">Glissez vos justificatifs ici ou cliquez pour parcourir</span>

                    {/* MOBILE TEXT: Visible on screens smaller than medium */}
                    <span className="d-inline d-md-none">Cliquez pour parcourir vos justificatifs</span>
               </span>
               <input type="file" multiple className="d-none" ref={fileInputRef} onChange={onFileSelect} accept=".pdf,.png,.jpg,.jpeg" />
          </div>
     </div>
)

export default Dropzone
